import { compact, get, isString, uniq } from 'lodash-es'

export default {
  props: {
    link: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    newAttrs() {
      return {
        ...this.$attrs,
        href: this.url,
        rel: this.rel,
        class: this.class,
        target: this.target,
        title: this.title,
      }
    },
    linkIsString() {
      return isString(this.link)
    },
    rel() {
      const noopener = get(this.$attrs, 'target') === '_blank' ? 'noopener' : null
      return uniq(
        compact([...this.linkRel, ...get(this.$attrs, 'rel', '').split(' '), noopener]),
      ).join(' ')
    },
    url() {
      return this.linkIsString ? this.link : get(this.link, 'url')
    },
    target() {
      return this.linkTarget || get(this.$attrs, 'target')
    },
    title() {
      return this.linkTarget || get(this.$attrs, 'title')
    },
    class() {
      return uniq(compact([...this.linkClass, ...get(this.$attrs, 'class', '').split(' ')])).join(
        ' ',
      )
    },
    linkRel() {
      return get(this.link, 'rel', '').split(' ')
    },
    linkTarget() {
      return get(this.link, 'target')
    },
    linkTitle() {
      return get(this.link, 'title')
    },
    linkAdditionalParams() {
      // ToDo: How to use these Params?
      return get(this.link, 'additionalParams')
    },
    linkClass() {
      return get(this.link, 'class', '').split(' ')
    },
  },
}
